import React, { ReactNode } from "react";
// import styles from "./Parentcontainer.module.scss";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
// import BackgroundGreen from "../../assets/images/green-background.svg";
// import Lock from "../../assets/images/lock.svg";
// import { ReactComponent as MenuIcon } from "../../assets/images/show-details.svg";
// import { ReactComponent as CloseIcon } from "../../assets/images/close.svg";
// import axios from "axios";
// import { useDispatch } from "react-redux";
// import {
//   openLoader,
//   closeLoader,
// } from "../../redux/actions/loader/loaderActions";

export default function ParentContainer({ children }: { children: ReactNode }) {
  // const [showDetails, setShowDetails] = useState(false);
  const useStyles = makeStyles({
    root: {
      // height: "647px",
      // width: "497px",
      margin: "0 auto",
      background: "#E5E5E5",
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      background: "#E5E5E5",
      position: "relative",
    },
  });
  const classes = useStyles();
  // const dispatch = useDispatch();
  // const [items, setItems] = useState<any>();

  // useEffect(() => {
  //   dispatch(openLoader());
  //   axios.get("./mockfolder/items.json").then((res: any) => {
  //     dispatch(closeLoader());
  //     setItems(res.data);
  //   });
  // }, []);

  return (
    <Grid classes={{ root: classes.style }}>
      <Grid
        item
        xs={12}
        md={7}
        xl={6}
        classes={{
          root: classes.root,
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
}
